import { EpgDetailDataSource } from './EpgDetailDataSource';
import { Backend } from '../../../api/Backend';
import { EpgApiV5 } from '../../../api/EpgApiV5';

export class ScheduleDetailDataSource extends EpgDetailDataSource {
  constructor(backend: Backend) {
    super(backend);
  }

  override load(scheduleId: string) {
    return Promise.all([EpgApiV5.schedule(this.backend, scheduleId), this.initChannels()]).then(([asset]) => {
      this.schedule = asset.schedule;
      if (asset.series?.text.title) {
        this.series = asset.series;
      }
      this.season = asset.season;
      this.channel = this.channelsList?.find(item => item.channelId === this.schedule?.channelId);

      return EpgApiV5.program(this.backend, asset.program.programId)
        .then(result => {
          this.program = result.program;

          //todo check adult
          return this.findRecordingForProgram();
        })
        .then(() => {
          return super.load(scheduleId);
        });
    });
  }
}
